 <div class="">
   <div class="card-title">
     <span>{{'ANSWER_SECURITY_QUESTIONS' | dictionary}}</span>
   </div>


   <form class="body-wrapper app-security-question" (ngSubmit)="submitTheAnswer()">
     <div class="question-wrapper" *ngIf="displayQuestions">
       <p>{{securityAnswers.SecQuestionText1}}</p>
       <input [(ngModel)]="securityAnswers.SecAnswerText1"  name="SecAnswerText1">
     </div>

     <div class="question-wrapper" *ngIf="displayQuestions">
       <p>{{securityAnswers.SecQuestionText2}}</p>
       <input [(ngModel)]="securityAnswers.SecAnswerText2"  name="SecAnswerText2">
     </div>

     <div class="question-wrapper" *ngIf="displayQuestions">
       <p>{{securityAnswers.SecQuestionText3}}</p>
       <input [(ngModel)]="securityAnswers.SecAnswerText3" name="SecAnswerText3">
     </div>

     <div class="actions-wrapper">
       <button class="ml-15 sec-button button-1" type="button" (click)="navigateHome()">{{'CANCEL' | dictionary}}</button>
       <button class="ml-15 sec-button button-1" type="submit">{{'SUBMIT' | dictionary}}</button>
     </div>
     <div class="link-2 reset-password-button" (click)="requestEmail()">
       Send me an email with a link to reset my password
     </div>
   </form>

 </div>

 <app-pop-up-dialog [Message]="alertMessage" [Display]="display" (DisplayBack)="display = false">
 </app-pop-up-dialog>


 <p-dialog header="" [(visible)]="displaySuccessMessage" [modal]="true" [resizable]="false" [focusOnShow]="true"
           class="forgotpasswordemaillink" [draggable]="false" (onHide)="hidePopupAndNavigateHome()">
   <div class="dialog-wrapper">
     <div class="col-lg-12 text-center">
       <h3>{{'REQUEST_SENT' | dictionary}}</h3>
       <p>{{'YOU_SHOULD_RECEIVE_EMAIL_NO_ADDRESS' | dictionary}}</p>
       <p style="margin-top: 15px;">{{'CHECK_SPAM_IF_YOU_DONT_RECEIVE_EMAIL' | dictionary : clientCode}}
       </p>
       <p style="margin-top: 10px;">{{'IF_YOU_CONTINUE_TO_HAVE_PROBLEM' | dictionary : clientName : clientPhoneNumber }}
       </p>
     </div>
   </div>
   <ng-template pTemplate="footer">
     <button class="button-1" type="button" (click)="hidePopupAndNavigateHome()">{{'CLOSE' | dictionary}}</button>
   </ng-template>
 </p-dialog>

